__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "BatthubdhApp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hero/federation-library", "1.0.5", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(757)]).then(() => (() => (__webpack_require__(75757))))));
			register("@hero/hero-auth-app", "1.6.2", () => (Promise.all([__webpack_require__.e(215), __webpack_require__.e(914), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(93215))))));
			register("@hero/hero-notifications-app", "1.3.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(342)]).then(() => (() => (__webpack_require__(37961))))));
			register("@hero/hero-platform-ui-app", "0.13.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(641)]).then(() => (() => (__webpack_require__(9641))))));
			register("@hero/hero-sdk", "0.10.1", () => (Promise.all([__webpack_require__.e(83), __webpack_require__.e(499)]).then(() => (() => (__webpack_require__(8499))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(248), __webpack_require__.e(425), __webpack_require__.e(928), __webpack_require__.e(646), __webpack_require__.e(400), __webpack_require__.e(674), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(833)]).then(() => (() => (__webpack_require__(94674))))));
			register("@mui/system", "5.18.0", () => (Promise.all([__webpack_require__.e(248), __webpack_require__.e(400), __webpack_require__.e(806), __webpack_require__.e(914), __webpack_require__.e(846)]).then(() => (() => (__webpack_require__(42425))))));
			register("@nrel-design-system/hero", "0.10.14", () => (Promise.all([__webpack_require__.e(248), __webpack_require__.e(425), __webpack_require__.e(928), __webpack_require__.e(775), __webpack_require__.e(397), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(833), __webpack_require__.e(241), __webpack_require__.e(582)]).then(() => (() => (__webpack_require__(71397))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-router-dom", "6.30.1", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "17.0.2", () => (__webpack_require__.e(778).then(() => (() => (__webpack_require__(64397))))));
			register("react", "17.0.2", () => (__webpack_require__.e(105).then(() => (() => (__webpack_require__(99105))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};